/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { getBackendUrl } from "@Utils";
import { useCallback, useEffect, useState } from "react";
import { MdArrowDropDown } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import axiosWrapper from "@Services/axiosWrapper";
import type {
  GetSelectedViewerLayoutResponse,
  SetSelectedViewerLayoutResponse,
} from "@ServerTypes/layoutView/layoutView.schema";
import { setModalStatus, setViewerState } from "@Reducers/Viewer";
import DesignViewerLayoutSetting from "../DesignViewerLayoutSetting";
import useModulesMapper from "@Components/StickySidebarViewer/ModulesMapper";
import { removingElementFromRcDock } from "@Services/utils/helpers";
import Views from "@Components/Views";
import _ from "lodash";

import { QueryBuilder, PredicateBuilder } from "@Services/queryBuilder";
import { Box } from "@mui/material";
import { showToastNotification } from "@Reducers/toastSlice";
import { TOAST_TYPE_SUCCESS } from "@Services/constants";
import { useTranslation } from "@i18n";
import { RootState } from "@Reducers/index";

interface DesignViewerLayoutManagerProps {
  HoopsViewer: any;
  modalToOpen?: string[];
  fileVersionId: string;
}

function DesignViewerLayoutManager({ HoopsViewer, modalToOpen = [], fileVersionId }: DesignViewerLayoutManagerProps) {
  const dispatch = useDispatch();
  const { layout } = useSelector((state: RootState) => state);
  const [LayoutDropdown, setLayoutDropdown] = useState<boolean>(false);
  const [availableData, setAvailableData] = useState<any[]>([]);
  const [addedData, setAddedData] = useState<any[]>([]);
  const [layoutSettingMenu, setLayoutSettingMenu] = useState<boolean>(false);
  const [updateData, setUpdateData] = useState<any>({});

  const [currentLayoutData, setcurrentLayoutData] = useState<any>(null);
  const [layoutData, setLayoutData] = useState<any[]>([]);
  const [defaultLayout, setDefaultLayout] = useState<any>({});
  const urlSearchParams = new URLSearchParams(location.search);

  const HoopsModalStatus = useSelector((state: RootState) => state.HoopsModalStatus);
  const HoopsModalStatusClone = _.cloneDeep(HoopsModalStatus);
  const [modulesMapper] = useModulesMapper({
    estimateId: !!urlSearchParams.get("estimateId"),
    fileVersionId,
  });
  const { t } = useTranslation();

  const getSelectedLayout = useCallback(async () => {
    const selectedViewerLayout = await axiosWrapper.post<GetSelectedViewerLayoutResponse>(
      `${getBackendUrl()}/layoutView/getSelectedViewerLayout`,
      {
        key: "VIEWER_SELECTED_LAYOUT",
      },
    );
    setcurrentLayoutData((selectedViewerLayout.data as any).data);
  }, []);

  const init = useCallback(async () => {
    await getSelectedLayout();
  }, [getSelectedLayout]);

  useEffect(() => {
    init();
  }, [init]);

  useEffect(() => {
    async function save() {
      if (LayoutDropdown) {
        await axiosWrapper.post<SetSelectedViewerLayoutResponse>(
          `${getBackendUrl()}/layoutView/setSelectedViewerLayout`,
          {
            selectedViewerId: currentLayoutData._id,
            key: "VIEWER_SELECTED_LAYOUT",
          },
        );
      }
      setLayoutDataInDesignViewer(currentLayoutData);
    }
    if (currentLayoutData) {
      save();
    }
  }, [currentLayoutData]);

  useEffect(() => {
    if (LayoutDropdown) {
      getLayoutData();
    }
  }, [LayoutDropdown]);

  async function getLayoutData() {
    const query1 = new QueryBuilder().where(new PredicateBuilder("resourceType", "equal", "VIEWER"));
    const layoutResponse = await axiosWrapper.post<{ status: boolean; data: any[] }>(
      `${getBackendUrl()}/layoutView/getViewData`,
      { value: query1.build() },
    );
    setLayoutData(layoutResponse.data.data);

    layoutResponse.data.data.map((data: any) => {
      if (data.isDefault) {
        setDefaultLayout(data);
      }
    });
  }

  async function setLayoutDataInDesignViewer(viewerData: any) {
    const viewerStateObject: any = {};
    let sidebar: any;
    let modalStatus: any = {};
    const activeIds: string[] = [];
    const nonActiveIds: string[] = [];
    if (viewerData.isDefault) {
      viewerStateObject.zoomLevel = 100;
      viewerStateObject.layoutRcDockData = false;
      sidebar = makeSidebarDataSequenceWise(layout.DESIGNVIEWER?.MODULES_ENABLED);
      const hoopsStatuses = { ...HoopsModalStatusClone };
      Object.keys(hoopsStatuses).map((data: string) => {
        if (data != "Viewer") {
          const entry = hoopsStatuses[data];
          if (entry) {
            entry.show = false;
          }
        }
      });
      modalStatus = hoopsStatuses;
    } else {
      sidebar = makeSidebarDataSequenceWise(viewerData.data.sidebarLayout.addedData);
      viewerStateObject.zoomLevel = viewerData.data.zoomLevel;
      viewerStateObject.layoutRcDockData = viewerData.data.rcDock;
      const rcDock = JSON.parse(JSON.stringify(viewerData.data.rcDock));
      Object.keys(rcDock).map((key: string) => {
        if (rcDock[key].children.length > 0) {
          rcDock[key].children.map((child: any) => {
            recusiveLoopForActiveSidebarInLayout(child, activeIds, nonActiveIds);
          });
        }
      });
      if (nonActiveIds.length > 0) {
        Object.keys(rcDock).map((key: string) => {
          if (rcDock[key].children.length > 0) {
            rcDock[key].children = rcDock[key].children.filter((child: any) =>
              removingElementFromRcDock(child, nonActiveIds),
            );
          }
        });
      }
      viewerStateObject.layoutRcDockData = rcDock;
      activeIds.forEach((dock: any) => {
        const initializeState = (modulesMapper as any)[dock]?.initialState || {};
        modalStatus[dock] = {
          show: true,
          ...initializeState,
        };
      });
      const hoopsStatuses = { ...HoopsModalStatusClone };
      Object.keys(hoopsStatuses).map((data: string) => {
        if (data != "Viewer") {
          const entry = hoopsStatuses[data];
          if (entry) {
            entry.show = false;
          }
        }
      });
      modalStatus = { ...hoopsStatuses, ...modalStatus };
    }
    viewerStateObject.sidebarData = sidebarFilterWithModulesEnabled(sidebar);
    if (modalToOpen.length > 0) {
      let filteredModalToOpen = modalToOpen.filter(
        (data) => !activeIds.includes(data) && (modulesMapper as any)[data]?.isVisible,
      );
      for (const dock of filteredModalToOpen) {
        const initializeState = (modulesMapper as any)[dock]?.initialState || {};
        modalStatus[dock] = {
          show: true,
          ...initializeState,
        };

        if (dock === "Issues") {
          modalStatus[dock].currentStage = "view_issue";
        }
      }
    }

    dispatch(setViewerState({ ...viewerStateObject, modalToOpen }));
    dispatch(setModalStatus(modalStatus));
  }

  function sidebarFilterWithModulesEnabled(layoutData: any) {
    return layoutData.filter((e: any) => (layout.DESIGNVIEWER?.MODULES_ENABLED?.indexOf(e) ?? -1) > -1);
  }

  function makeSidebarDataSequenceWise(sidebar: any) {
    const sidebarAsPerRelation = sidebarGrouping(sidebar);
    const result: any[] = [];
    Object.keys(sidebarAsPerRelation).map((data: string) => {
      result.push(...sidebarAsPerRelation[data]);
    });
    return result;
  }

  function recusiveLoopForActiveSidebarInLayout(child: any, activeIds: string[], nonActiveIds: string[]) {
    if (child.children?.length > 0) {
      child.children.map((child: any) => {
        recusiveLoopForActiveSidebarInLayout(child, activeIds, nonActiveIds);
      });
    }
    if (child.tabs) {
      child.tabs.map((tab: any) => {
        if (!(modulesMapper as any)[tab.id] || (modulesMapper as any)[tab.id]?.isVisible) {
          activeIds.push(tab.id);
        } else {
          nonActiveIds.push(tab.id);
        }
      });
    }
  }

  function sidebarGrouping(sidebar: any, dataToAvoid: any[] = []) {
    const sidebarAsPerRelation: any = [];
    sidebar.map((data: any) => {
      if (
        !dataToAvoid.includes(data) &&
        (layout.DESIGNVIEWER?.MODULES_ENABLED?.indexOf(data) ?? -1) > -1 &&
        data != "Divider"
      ) {
        if (sidebarAsPerRelation[(modulesMapper as any)[data]?.belongToGroup]) {
          sidebarAsPerRelation[(modulesMapper as any)[data]?.belongToGroup] = [
            ...sidebarAsPerRelation[(modulesMapper as any)[data]?.belongToGroup],
            data,
          ];
        } else {
          sidebarAsPerRelation[(modulesMapper as any)[data]?.belongToGroup] = [data];
        }
      }
    });
    return sidebarAsPerRelation;
  }
  function makeDnDComponentData({
    addedData,
    makeAddedData,
    makeAvailableData,
  }: {
    addedData: any;
    makeAddedData: boolean;
    makeAvailableData: boolean;
  }) {
    const dataToAvoid: any[] = [];
    if (makeAvailableData) {
      dataToAvoid.push(...addedData);
    }
    const portalAvailableSidebarOption = makeAddedData ? addedData : layout.DESIGNVIEWER?.MODULES_ENABLED;
    const sidebarAsPerRelation = sidebarGrouping(portalAvailableSidebarOption, dataToAvoid);
    const result: any[] = [];
    Object.keys(sidebarAsPerRelation).map((data: string) => {
      result.push({
        [data]: {
          widgets: sidebarAsPerRelation[data],
        },
      });
    });
    return result;
  }

  function createNewLayoutData() {
    const defaultAddedData = layout.DESIGNVIEWER?.MODULES_ENABLED;
    const newLayout = HoopsViewer.rcDockref.saveLayout();
    return {
      rcDock: { ...JSON.parse(JSON.stringify(newLayout)) },
      sidebarLayout: {
        addedData: defaultAddedData,
      },
      zoomLevel: 100,
    };
  }

  async function onClickLayout(clickLayout: any) {
    setcurrentLayoutData(clickLayout);
  }

  async function onDuplicateCallback({ duplicatedData }: { duplicatedData: any }) {
    dispatch(
      showToastNotification({
        content: t("designviewer_layout_duplicated", { layoutName: duplicatedData.name }),
        type: TOAST_TYPE_SUCCESS,
      }),
    );
  }

  async function onRenameCallback({ renameData }: { renameData: any }) {
    dispatch(
      showToastNotification({
        content: t("designviewer_layout_renamed", { layoutName: renameData.name }),
        type: TOAST_TYPE_SUCCESS,
      }),
    );
    if (renameData._id == currentLayoutData._id) {
      setcurrentLayoutData(renameData);
    }
  }

  async function onEditCallback({ layoutData, layoutDataIndex }: { layoutData: any; layoutDataIndex: number }) {
    setUpdateData({ ...layoutData, layoutDataIndex });
    setLayoutSettingMenu(true);
    const addedData = makeDnDComponentData({
      addedData: layoutData.data.sidebarLayout.addedData,
      makeAddedData: true,
      makeAvailableData: false,
    });
    setAddedData(addedData);
    const availableData = makeDnDComponentData({
      addedData: layoutData.data.sidebarLayout.addedData,
      makeAddedData: false,
      makeAvailableData: true,
    });
    setAvailableData(availableData);
  }

  async function onSaveSettingCallback({ updateData }: { updateData: any }) {
    setLayoutData((prevState) => {
      const tempData = prevState;
      tempData[updateData.layoutDataIndex] = updateData;
      return tempData;
    });
    dispatch(
      showToastNotification({
        content: t("designviewer_layout_updated", { layoutName: updateData.name }),
        type: TOAST_TYPE_SUCCESS,
      }),
    );
    if (updateData._id == currentLayoutData._id) {
      setcurrentLayoutData({ ...updateData });
    }
  }

  async function onDeleteCallback({ deleteData }: { deleteData: any }) {
    dispatch(
      showToastNotification({
        content: t("designviewer_layout_deleted", { layoutName: deleteData.name }),
        type: TOAST_TYPE_SUCCESS,
      }),
    );
    if (deleteData._id == currentLayoutData._id) {
      setcurrentLayoutData(defaultLayout);
    }
  }

  return (
    <>
      <div
        className="layoutManagerRoot preventLayoutClose relative flex items-center ps-3.5 pe-3.5 font-semibold"
        data-testid="layoutManagerRoot"
        id="layoutDropDown"
      >
        <Box
          onClick={() => setLayoutDropdown(!LayoutDropdown)}
          className="flex items-center cursor-pointer"
          data-testid="layoutDropdown"
        >
          <div className="overflow-hidden whitespace-nowrap text-ellipsis max-w-40" data-testid="currentLayoutDataName">
            {currentLayoutData?.name}
          </div>
          <MdArrowDropDown size="1.5rem" />
        </Box>
        {LayoutDropdown && (
          <div
            className="absolute top-8 start-0 flex w-[27.5rem] flex-col justify-between overflow-auto rounded-lg bg-white p-6 text-[var(--primary-text)] shadow-[0.25rem_0.25rem_0.9375rem_0_rgba(65,92,171,0.15)]"
            data-testid="layoutDropdownContent"
          >
            <Views
              layoutData={layoutData}
              setLayoutData={setLayoutData}
              currentDataId={_.get(currentLayoutData, "_id")}
              onClickLayout={onClickLayout}
              onRenameCallback={onRenameCallback}
              onEditCallback={onEditCallback}
              onDeleteCallback={onDeleteCallback}
              createNewLayoutData={createNewLayoutData}
              enableUpdate
              name="Layout"
              onDuplicateCallback={onDuplicateCallback}
            />
          </div>
        )}
      </div>
      {layoutSettingMenu && (
        <DesignViewerLayoutSetting
          updateData={updateData}
          setLayoutSettingMenu={setLayoutSettingMenu}
          availableData={availableData}
          setAvailableData={setAvailableData}
          addedData={addedData}
          setAddedData={setAddedData}
          HoopsViewer={HoopsViewer}
          setUpdateData={setUpdateData}
          onSaveCallback={onSaveSettingCallback}
        />
      )}
    </>
  );
}

export default DesignViewerLayoutManager;
